import api from '~/services/api';
import { v4 } from 'uuid';
import { toast } from 'react-toastify';
import { formatCurrencyAsText } from '~/utils/functions';

export async function getItensFiscal(
    cod_seq_cupom: string | number | undefined,
): Promise<any[]> {
    try {
        const { data } = await api.get(`/manutencao-fiscal/fiscal-nfce/${cod_seq_cupom}`);
        if (data.data) {
            const itensFiscalNfce = data.data.map((item: any, index: any) => {
                item.num_item = index + 1;
                item.id = v4();
                return item;
            });
            return itensFiscalNfce;
        }
        return [];
    } catch (error: any) {
        toast.warning('Itens da NF não encontrado');
        return [];
    }
}
